<!--
 * @Author: hongye
 * @Date: 2020-09-17 18:54:44
 * @LastEditTime: 2020-09-23 14:12:56
 * @Description: 
-->
<template>
  <div class="apiDocIndex">
    <p class="api_doc_h3">
      <i class="iconfont iconapiwendang_jianjie"></i><span>{{$t('apiDoc.API简介')}}</span>
    </p>
    <p class="api_doc_text">{{$t('apiDoc.IntroductionContent')}}</p>
    <p class="api_doc_h3">
      <i class="iconfont iconapiwendang_duijieliucheng"></i><span>{{$t('apiDoc.对接流程')}}</span>
    </p>
    <div class="api_doc_text_w">
      <p class="api_doc_text">{{$t('apiDoc.process_1')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.process_2')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.process_3')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.process_4')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.process_5')}}</p>
    </div>
    <p class="api_doc_h3">
      <i class="iconfont iconapiwendang_qianmingfangshi"></i><span>{{$t('apiDoc.签名方式')}}</span>
    </p>
    <div class="api_doc_text_w">
      <p class="api_doc_text">{{$t('apiDoc.method_1')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.method_2')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.method_3')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.method_4')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.method_5')}}</p>
      <p class="api_doc_text">{{$t('apiDoc.method_6')}}</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "apiDocIndex",
  data() {
    return {};
  },
  components: {},
};
</script>

<style scoped lang="scss">
.apiDocIndex {
  box-sizing: border-box;
  padding: 20px 30px;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  .iconfont {
    font-size: 24px;
    color: $theme-color;
    margin-right: 14px;
  }
  .api_doc_h3 {
    font-size: 22px;
    color: #2b2d42;
    line-height: 42px;
    &:not(:nth-of-type(1)) {
      margin-top: 30px;
    }
    span {
      font-weight: 600;
    }
  }
  .api_doc_text {
    font-size: 14px;
    color: #61666d;
    line-height: 22px;
    margin-top: 25px;
  }
}
[dir="rtl"] .apiDocIndex {
    .iconfont {
    margin-right: 0;
    margin-left: 14px;
  }
}
</style>
